// extracted by mini-css-extract-plugin
export var box = "_48-0";
export var check = "_48-1";
export var checkboxButton = "_48-6";
export var checkboxGroup = "_48-5";
export var disabled = "_48-7";
export var ghost = "_48-9";
export var input = "_48-2";
export var label = "_48-4";
export var normal = "_48-8";
export var uncheck = "_48-3";